// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"5c627fa8","96":"06ce0330","233":"b89ec5b0","453":"04c79a43","469":"fa98c32e","906":"94db3d3e","997":"4647aa5a"}[chunkId] + ".chunk.js";
};